import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import "../Style/AboutUs.css";
import "../Style/Responsive.css";
// import ChatBot from "./Chatbot";


//images for team members
import sandeep from "../Images/Sandeep.png";
import FootprintEA from "../Images/FootprintEA.jpg";
import FootprintTech from "../Images/FootprintTech.jpg";
import FootprintFamBiz from "../Images/FootprintFamBiz.jpg";
import FootprintPhilanthropy from "../Images/FootprintPhilanthropy.jpg";
//icons
import { FaLinkedin,  FaEnvelope } from 'react-icons/fa';

 
function AboutUs() {
  const { t } = useLanguage();
  return (
    <div className="about-us-container">
       {/* About Us Section with Video Background */}
       <section id="about-us" className="about-section">
        {/* Video Background */}
        <div className="video-background">
          <video autoPlay muted loop playsInline className="background-video">
          
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay"></div>
        </div>

        <div className="about-content">
          <h2>{t('nav_about')}</h2>
          <p>
            Passion, it’s what drives entrepreneurs, it’s also what inspires KPMG
            Private Enterprise advisors to help you maximize success. We help you
            uncover and capture new opportunities in ever-evolving markets.
          </p>
          <p>
          It is an initiative to support start ups build robust business models, 
          develop scalable solutions and create impactful and economic value. 
          </p>
          <p>The centre will offer resources, mentorship, networking, expert advisory services 
            and a collaborative platform tailored to the needs of start ups.
          </p>
        </div>
      </section>
      <hr className="videoslide-divider" />
      {/* Private Businesses Key Target Segments Section */}
      <section id="key-target-segments" className="key-targets-section">
        <h2>Private businesses are primarily focused on key target segments</h2>
        <div className="key-targets-grid">
          <div className="key-target-card">
            <h3>Startups</h3>
          </div>
          <div className="key-target-card">
            <h3>Emerging Growth Companies</h3>
          </div>
          <div className="key-target-card">
            <h3>Family Businesses</h3>
          </div>
          <div className="key-target-card">
            <h3>Scaleups</h3>
          </div>
        </div>
      </section>

      {/* How We Can Help Section */}
      <section id="how-we-can-help" className="help-section">
        <h2>How We Can Help</h2>
        <div className="help-content">
          <h4>
            Whether you're a high-growth VC or PE-backed company, family business,
            or family office, KPMG Private Enterprise focuses on your success now and
            in the future. We help private companies uncover and capture new
            opportunities in their markets.
          </h4>
        </div>

        {/* New Stakeholders / "How We Can Address These Needs" Subsection */}
        <h2 className="stakeholders-title">
        The Centre of excellence can address stakeholders needs through a holistic and comprehensive approach 
        </h2>
        <div className="stakeholders-section">
          {/* SMEs */}
          <div className="stakeholder-card smes">
            <h3>SMEs</h3>
            <p>Provide access to cutting-edge subscription-based services and expert-led training programs tailored to adequately prepare these businesses for growth.</p>
            <ul>
              <li>Connect SMEs with industry experts, mentors, and investors</li>
              <li>Offer scalable tech solutions</li>
              <li>Provide ongoing mentorship and business model consultation</li>
            </ul>
          </div>

          {/* Investors */}
          <div className="stakeholder-card investors">
            <h3>Investors</h3>
            <p>Showcase high-potential SMEs and other growth platforms to connect with new investment prospects.</p>
            <ul>
              <li>Assist investors with identifying promising ventures</li>
              <li>Streamlined diligence and investment lifecycle</li>
            </ul>
          </div>

          {/* Incubators */}
          <div className="stakeholder-card incubators">
            <h3>Incubators</h3>
            <p>Provide incubators with a one-stop shop for training and support of their joint educational programs and speed pitching events.</p>
            <ul>
              <li>Offer program synergy</li>
              <li>Shared mentorship and resources</li>
              <li>Tech upskilling and specialized training</li>
            </ul>
          </div>

          {/* Regulators */}
          <div className="stakeholder-card regulators">
            <h3>Regulators</h3>
            <p>Provide the platform for regulatory insights, feedback from SMEs, and investor alignment to drive compliance while maintaining agility.</p>
            <ul>
              <li>Boosting regulatory transparency</li>
              <li>Helping shape SME-friendly policies</li>
              <li>Encouraging responsible innovation</li>
            </ul>
          </div>

          {/* Consumers */}
          <div className="stakeholder-card consumers">
            <h3>Consumers</h3>
            <p>Provide consumers with businesses that have sustainable solutions to meet their needs. Build brand confidence for businesses that pass compliance checks.</p>
            <ul>
              <li>Elevated consumer trust</li>
              <li>Increased product availability</li>
              <li>Access to credible, innovative solutions</li>
            </ul>
          </div>
        </div>
      </section>

     {/* The 360 Experience Section */}
<section id="360-experience" className="experience-section">
  <h2>The 360° Experience</h2>
  <div className="experience-grid">
    <div className="experience-card">
      <h4>Strategic Vision</h4>
      <p className="experience-description">
        We empower you to navigate market dynamics and set a course for sustainable success.
      </p>
      <ul className="experience-details">
        <li>Strategy & Planning</li>
        <li>Market Analysis</li>
        <li>Competitive Benchmarking</li>
      </ul>
    </div>
    <div className="experience-card">
      <h4>Digital Transformation</h4>
      <p className="experience-description">
        Embrace technology that drives innovation and operational excellence.
      </p>
      <ul className="experience-details">
        <li>Tech Advisory</li>
        <li>Digital Enablement</li>
        <li>Cyber Security</li>
      </ul>
    </div>
    <div className="experience-card">
      <h4>Operational Excellence</h4>
      <p className="experience-description">
        Optimize your operations to unlock efficiency and mitigate risk.
      </p>
      <ul className="experience-details">
        <li>Risk Management</li>
        <li>Governance & Compliance</li>
        <li>Internal Audit</li>
      </ul>
    </div>
    <div className="experience-card">
      <h4>Value Creation</h4>
      <p className="experience-description">
        Deliver measurable results through improved ROI, revenue growth, and margin enhancement.
      </p>
      <ul className="experience-details">
        <li>Realize ROI</li>
        <li>Grow Revenue</li>
        <li>Improve Margin</li>
      </ul>
    </div>
  </div>
</section>

      {/* Our Value Proposition Section */}
      <section id="value-proposition" className="value-proposition-section">
        <h2>Our Value Proposition</h2>
        <h3>Why clients choose to work with us:</h3>
        <div className="value-proposition-grid">
          <div className="value-card">
            <p>We have the knowledge to navigate global aspirations for business success</p>
          </div>
          <div className="value-card">
            <p>We have a dedicated global network of professionals</p>
          </div>
          <div className="value-card">
            <p>We deliver insights to get you faster results</p>
          </div>
          <div className="value-card">
            <p>We provide cross-functional services; 
            one-stop-shop technology-enabled</p>
          </div>
        </div>
      </section>

       {/* Our Footprint Section */}
       <section className="footprint-section">
        <h2>Our Footprint</h2>
        <div className="footprint-grid">
          <div className="footprint-card">
            <img src={FootprintEA} alt="East Africa Mid-Sized Companies" />
            <div className="footprint-text">
              <h3>East Africa Top100 Mid-Sized Companies Survey</h3>
              <p>
                KPMG works with East Africa's fastest-growing medium-sized 
                companies to showcase business excellence and highlight 
                successful entrepreneurship stories in Kenya, Uganda, and Tanzania.
              </p>
            </div>
          </div>

          <div className="footprint-card">
            <img src={FootprintTech} alt="Global Tech Innovator" />
            <div className="footprint-text">
              <h3>Global Tech Innovator Competition</h3>
              <p>
                KPMG recognizes Africa’s most exciting, fast-growth, innovation-based 
                ventures through an annual competition. We are supporting tomorrow’s 
                emerging giants.
              </p>
            </div>
          </div>

          <div className="footprint-card">
            <img src={FootprintFamBiz} alt="Family Business Barometer" />
            <div className="footprint-text">
              <h3>African Family Business Barometer</h3>
              <p>
                KPMG is helping family offices and private clients stay ahead of change. 
                Through our bi-annual African family business barometer, family businesses 
                stay in tune with the latest developments in the region.
              </p>
            </div>
          </div>

          <div className="footprint-card">
            <img src={FootprintPhilanthropy} alt="Philanthropy in Action" />
            <div className="footprint-text">
              <h3>Philanthropy in Action</h3>
              <p>
                KPMG’s Family Office & Private Client team has conducted extensive 
                research, sharing leading practices in philanthropy and how ultra-high-net-worth 
                individuals (UHNWIs) and family offices are giving back across the globe.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section id="our-team" className="team-section">
      <h2>Meet Our Leader</h2>
      <div className="team-leader-container">
        {/* Leader Profile Card */}
        <div className="leader-profile">
          <a
            href="https://www.linkedin.com/in/sandeep-main/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="team-card">
              <img src={sandeep} alt="Sandeep Main" />
              <h4>Sandeep Main</h4>
              <p>Partner, Tax & Regulatory Services and Head of Private Enterprise and Family Office</p>
              <p>KPMG in Kenya</p>
              <div id="profile-card">
                <a
                  href="https://www.linkedin.com/in/sandeep-main/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin /> Profile
                </a>
                <span className="separator"> | </span>
                <a
                  href="https://kpmg.com/ke/en/home/contacts/m/sandeep_main.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaEnvelope /> Email
                </a>
              </div>
            </div>
          </a>
        </div>


        {/* Leader CV / About Section */}
        <div className="leader-cv">
          <h3>About Sandeep Main</h3>
          <p>
            Sandeep is a Partner in the Tax and Regulatory Services department. He has over 10 years of tax experience including international experience having been seconded to KPMG Canada, where he provided tax advisory and compliance services to diverse clients.
          </p>
          <p>
            He has been involved in general and specialized tax compliance services, health check review services, VAT reviews, planning and implementing efficient tax structures, and developing tax saving mechanisms for KPMG’s clients.
          </p>
          <p>
            Sandeep has undertaken tax planning and tax risk management for various clients to help them structure their business operations in a tax-efficient manner as they set up in Kenya and other jurisdictions. He has advised several international investors in tax-efficient operational structures and assisted clients during in-depth assessments by revenue and regulatory authorities.
          </p>
          <p>
            Actively involved in strategic tax planning and advisory services—including mergers, acquisitions, reorganizations, investor tax advisory, due diligence reviews, and tax training—Sandeep’s portfolio includes prominent clients in financial services, NGOs, agriculture, and manufacturing.
          </p>
          <p>
            Sandeep is a Fellow of the Association of Chartered Certified Accountants (FCCA) and currently serves as the vice chair of the advisory committee and as the chair of the ACCA Tax Forum. He is also a member of the ICPAK training committee.
          </p>
          <p>
            Additionally, Sandeep doubles up as the KPMG Enterprise lead, heading a team of specialists who work with private, mid-market, and emerging businesses—the engine room of the Kenyan economy.
          </p>
          <h4>Education and Qualifications</h4>
          <p><strong>Bachelor of Science degree</strong>, Oxford Brookes University</p>
          <p><strong>Accreditation:</strong> Fellow of the Association of Chartered Certified Accountants (ACCA)</p>
          <p>
            Chairman of the Advisory Board and leader of the Public Policy Committee, ACCA; Member of the Institute of Certified Public Accountants of Kenya (ICPAK)
          </p>
        </div>
      </div>
    </section>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-container">
          <div className="footer-links">
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><a href="#360-experience"  target="_blank" rel="noopener noreferrer">360 Experience</a></li>
              <li><a href="#our-team"  target="_blank" rel="noopener noreferrer">Our Team</a></li>
              <li><a href="https://kpmg.com/ke/en/home/misc/privacy.html"  target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              <li><a href="https://kpmg.com/ke/en/home/misc/legal.html"  target="_blank" rel="noopener noreferrer">Legal</a></li>
              <li><a href="https://kpmg.com/ke/en/home/insights/2024/04/terms_and_conditions_kpmg-private-enterprise-east-africa-tech-annovator-2024.html"  target="_blank" rel="noopener noreferrer">Terms & Conditions</a></li>
              <li><a href="https://assets.kpmg.com/content/dam/kpmg/ke/pdf/ea/KPMG%20Private%20Enterprise%20East%20Africa%20Capability%20Statement.pdf"  target="_blank" rel="noopener noreferrer">Capability Statement</a></li>
            </ul>
          </div>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/kpmgeastafrica/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
            <a href="https://x.com/KPMGEastAfrica/" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
            <a href="https://www.facebook.com/KPMGEA/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          </div>
        </div>
      </footer>

      {/* Chatbot component */}
      {/* <ChatBot /> */}
    </div>
  );
}

export default AboutUs;
